import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SingleSplitScrollBanner = () => {
  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [sliders, setSliders] = useState([
    {
      img: "/assets/img/metabolism-weight.jpg",
      title: "Metabolism & Weight",
      variant: "FTO Variant",
      risk:
        "Increased susceptibility to weight gain on high-carb diets",
    },
    {
      img: "/assets/img/stress-recovery.jpg",
      title: "Stress & Recovery",
      variant: "COMT Variant",
      risk:
        "Higher cortisol sensitivity → prolonged stress response",
    },
    {
      img: "/assets/img/detox-inflammation.jpg",
      title: "Detox & Inflammation",
      variant: "COMT Variant",
      risk:
        "Reduced antioxidant defense & slower toxin clearance",
    },
    {
      img: "/assets/img/metabolism-weight.jpg",
      title: "Metabolism & Weight",
      variant: "FTO Variant",
      risk:
        "Increased susceptibility to weight gain on high-carb diets",
    },
    {
      img: "/assets/img/stress-recovery.jpg",
      title: "Stress & Recovery",
      variant: "COMT Variant",
      risk:
        "Higher cortisol sensitivity → prolonged stress response",
    },
    {
      img: "/assets/img/detox-inflammation.jpg",
      title: "Detox & Inflammation",
      variant: "COMT Variant",
      risk:
        "Reduced antioxidant defense & slower toxin clearance",
    },

  ])

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const innerWidth = window.innerWidth;
      //   console.log(windowHeight,innerWidth);

      // When the section enters viewport, start calculating progress
      const scrollProgress = Math.min(
        Math.max((windowHeight - rect.top - 920) / (rect.height + windowHeight), 0),
        1
      );

      setProgress(scrollProgress);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const settingss = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: window.innerWidth > 600 ? 3 : 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "0",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 300,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="overflow-hidden y_dna position-relative" ref={sectionRef} >
      {/* FIRST SECTION */}
      <motion.div
        className="banner"
        style={{
          opacity: 2,
          clipPath: `inset(0 ${progress * 800}% 0 ${progress * 800}%)`,
        }}
      >
        <section className="bg2 cht_section">
          <div className="container position-relative">
            <div className="your_dna">
              <h2 className="hadding mb-3 color5">
                Your DNA Already Holds All the Answers
              </h2>
              <p>
                The signs of fatigue, stress, or weight gain aren’t random;
                they’re written in your genes and metabolism. EPLIMO decodes
                them, revealing the exact state of your health and what you can
                do about it.
              </p>
            </div>
            <div className="row position-relative">
              <div className="col-md-7 m-auto">
                <div className="come_box position-relative">
                  <img src="/assets/img/comt.png" className="img-fluid" />
                  <div className="come_box2">
                    <h3 className="d-flex align-items-center gap-2">
                      <img src="/assets/img/has.png" className="r_icon" /> COMT
                      Variant
                    </h3>
                    <p className="op0_5 mb-0">
                      Higher susceptibility to weight gain on high-carb diets
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </motion.div>

      {/* SECOND SECTION */}
      <motion.div
        className="next-section"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: progress * 20, scale: 1 + 0.2 * progress }}
        transition={{ duration: 0.3 }}
      // style={{
      //   // opacity: progress,
      //   transform: `scale(${0.8 + 0.2 * progress}) translateY(${(1 - progress) * 50}px)`, 
      // }}
      >
        <section className="whats-included_section">
          <div className="container">
            <div className="text-center pb-5">
              <h2 className="hadding mb-4 color3 text-center">
                Decode Your DNA.
                <br />
                Reveal What’s Really Going On Inside.
              </h2>
              <p className="mb-md-4 mb-3">
                Genetic insights + metabolic profiling uncover the why behind
                your symptoms so you can finally take control with precision
                solutions.
              </p>
              <a href="#" className="btn">
                Join EPLIMO<sup className="sup-font">TM</sup> Program
              </a>
            </div>
            <div>
              <Slider {...settingss}>
                {sliders.map((item, i) => (
                  <div key={i} className="item">
                    <div className="come_box_in position-relative">
                      <img src={item.img} className="w100" />
                      <div className="come_box2">
                        <h3 className="d-flex align-items-center justify-content-center gap-2 mb-0">
                          <img src="/assets/img/has.png" className="r_icon" />
                          {item.title}
                        </h3>
                        <p className="op0_5 ms-4 ps-3 mb-1">{item.variant}</p>
                        <p className="mb-0">
                          Risk: <span className="op0_5">{item.risk}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </section>
      </motion.div>

      <style>{`
      
        .banner {
          z-index: 2;
          overflow: hidden;
        }
        .next-section {
          position: absolute;
          top: 0;
          width: 100%;

        }
      `}</style>
    </div>
  );
};

export default SingleSplitScrollBanner;